import { ServiceLocation, UserDetails } from 'app/api/@generated/backend';

class OrderInformationUtils {
    public static getFullAddress(serviceLocation: ServiceLocation): string {
        const { address } = serviceLocation;

        const showDwellingUnitNumber = address.dwellingUnitNumber ? `${address.dwellingUnitNumber},` : '';

        return `${address.streetAddress || address.streetAddress2 || ''}, ${showDwellingUnitNumber} ${
            address.postalCode
        } ${address.city}`;
    }

    public static getShortAddress(serviceLocation: ServiceLocation): string {
        const { address } = serviceLocation;

        return `${address.streetAddress || address.streetAddress2 || ''}`;
    }

    public static getFullName(user: UserDetails): string {
        return `${user.firstName} ${user.lastName}`;
    }
}

export { OrderInformationUtils };
